export default class EstoqueParceiro {
  id: number;
  centro: string;
  material: string;
  quantidade: number;
  unidadeMedida: string;
  d_E_L_E_T_E: boolean;
  criadoEm: Date;
  excluidoEm: Date;

  constructor(
    id: number,
    centro: string,
    idSku: string,
    quantidade: number,
    unidadeMedida: string,
    d_E_L_E_T_E?: boolean,
    criadoEm?: Date,
    excluidoEm?: Date
  ) {
    this.id = id;
    this.centro = centro;
    this.material = idSku;
    this.quantidade = quantidade;
    this.unidadeMedida = unidadeMedida;
    this.d_E_L_E_T_E = d_E_L_E_T_E ?? false;
    this.criadoEm = criadoEm ?? new Date();
    this.excluidoEm = excluidoEm ?? new Date();
  }

  static toJson(EstoqueParceiro: EstoqueParceiro): string {
    return JSON.stringify(EstoqueParceiro);
  }

  static fromJson(json: object[]): EstoqueParceiro[] {
    let estoqueInsumos: EstoqueParceiro[] = [];
    json.forEach((item: any) => {
      estoqueInsumos.push(
        new EstoqueParceiro(
          item["id"],
          item["centro"],
          item["material"],
          item["quantidade"],
          item["unidadeMedida"],
          item["d_E_L_E_T_E"],
          item["criadoEm"],
          item["excluidoEm"]
        )
      );
    });
    return estoqueInsumos;
  }
}
